import getToken from '../account/getToken'
import {editFundNews} from '../../api/fundNews'

export default store => async (itemId, item) => {
  const token = await getToken(store)()

  if (!token) return

  return editFundNews({
    itemId,
    token,
    item,
  })
    .then(res => {
      if (!res.ok) {
        throw new Error('Item could not be saved.')
      } else {
        return res.json()
      }
    })
    .catch(error => {
      throw error
    })
}
